import { useEffect } from "react";
import { Icon } from "@iconify/react";

const TrucksGPS = ({ show, onClose }) => {
  useEffect(() => {
    // const handleEscKey = (event) => {
    //   if (event.key === "Escape" && show) {
    //     onClose();
    //   }
    // };

    if (show) {
      document.body.style.overflow = "hidden"; // Evita el scroll del body cuando el modal está abierto
      // document.addEventListener("keydown", handleEscKey);
    } else {
      document.body.style.overflow = ""; // Restaura el scroll del body cuando el modal se cierra
      // document.removeEventListener("keydown", handleEscKey);
    }

    return () => {
      document.body.style.overflow = ""; // Asegura que se restaure el scroll del body al desmontar el modal
      // document.removeEventListener("keydown", handleEscKey);
    };
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-30 px-4 bg-zinc-950 bg-opacity-50 flex items-center justify-center transition-opacity"
      onClick={onClose}
    >
      <div
        className="min-w-[374px] w-[374px] sm:w-[629px] md:w-[759px] lg:w-[1014px] xl:w-[1269px] bg-zinc-900 border border-zinc-700 rounded-2xl p-6 shadow-lg relative opacity-100 transform scale-100 transition-all duration-300"
        onClick={(e) => {
          e.stopPropagation();
        }}
        role="button"
        tabIndex="0"
      >
        <button
          className="bg-neutral-800 hover:bg-neutral-700 text-gray-400 hover:text-gray-200 p-[7px] rounded-lg absolute top-3.5 right-3.5"
          onClick={onClose}
        >
          <Icon icon="ic:round-close" className="text-lg" />
        </button>
        <h3 className="text-xl sm:text-2xl font-bold">TrucksGPS</h3>
        <h4 className="text-sm sm:text-base font-semibold">
          Aplicación Móvil para Gestión Integral de Flotas y Recursos.
        </h4>
        <p className="text-sm sm:text-base font-light">
          Una aplicación móvil desarrollada en Java que optimiza la gestión de
          flotas de transporte de carga. Utiliza Firebase Authentication para el
          acceso seguro de usuarios. La integración con Firebase Realtime
          Database permite el almacenamiento y gestión dinámica de datos
          críticos como documentos legales y ubicación en tiempo real de los
          vehículos. Firebase Cloud Messaging se emplea para enviar alertas
          instantáneas sobre desvíos de ruta, recordatorios de vencimiento de
          documentos y actualizaciones importantes. Además, Google Maps Platform
          facilita la planificación de rutas eficientes y la visualización
          detallada del progreso de los vehículos. TrucksGPS genera reportes
          detallados sobre el rendimiento de las rutas, tiempos de entrega y
          otros indicadores clave, ayudando a tomar decisiones estratégicas
          basadas en datos concretos. Mejora la eficiencia operativa, garantiza
          el cumplimiento normativo y asegura la seguridad en las operaciones de
          transporte de carga.
        </p>
        <div className="flex items-center gap-1">
          <Icon className="w-10 h-10" icon="devicon:androidstudio"></Icon>
          <Icon className="w-10 h-10" icon="logos:java"></Icon>
          <Icon className="w-10 h-10" icon="logos:firebase"></Icon>
          <Icon className="w-10 h-10" icon="logos:google-maps"></Icon>
        </div>
      </div>
    </div>
  );
};

export default TrucksGPS;
